import HeadNav from "../../components/HeadNav";
import {cutPhone, cutPhone1, showTotalData, fmDate, encrypt, LZStringCompress} from "../../tools";
import ListEmpty from "../../components/ListEmpty";
import {fetchPost,fetchGet,fetchGetNews,fetchPostNews} from "../../tools/https"
import {BigNumberStr,BigNumberMul,BigNumberDiv,BigNumberAdd,BigNumberSub,substringStr,substringStr1} from "../../tools/indexFun";
import localStore from '../../tools/localstorage'
export default {
  name: "Comment",
  components: {
    HeadNav,
    ListEmpty
  },
  data() {
    return {
      id: null,
      messages: [],
      value: null,
    }

  },
  created() {
  },
  methods: {
    BigNumberStr(num1,num2,col){
      return BigNumberStr(num1,num2,col);
    },
    substringStr(str = "", chars = 3){
      return substringStr(str, chars)
    },
    substringStr1(str = "", chars = 10){
      return substringStr1(str, chars)
    },
    async getDepositLog() {
      this.id = this.$route.params?.id
      fetchGetNews('comment/list',{page:1,size:20,id:this.id}).then((data)=>{
        // console.log('data',data)
        this.messages = data?.data?.list
      })
    },
    async refresh() {
      this.getDepositLog();
    },
    async onSearch(){
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
      });
      let obj = {
        info:this.value,
        author:this.$store.state.accounts[0],
        news_id:this.id
      }
      // console.log('111',obj)
      fetchPostNews('comment/list/add',obj).then((data)=>{
          // console.log('data',data)
        this.getDepositLog();

        this.$toast.clear();
      }).catch((err)=>{
        this.$toast.clear();
      })
      this.value=null
    },
  },
  mounted() {
    this.refresh();
  }
}
